// Package imports:
import React, { useEffect } from 'react';
// Style imports:
// import './BookmarksAll.scss';
// Component imports:
import Container from 'react-bootstrap/Container';
import HomeBookmarks from './HomeBookmarks';

const BookmarksAll: React.FC = () => {
    useEffect(() => {
        document.title = 'Bookmarks | KODIAK Sigti';
    }, []);

    return (
        <Container id='BookmarksAll' fluid>
            <HomeBookmarks
                showDateInTimestamp={true}
                reverseSort={true}
            />
        </Container>
    );
}

export default BookmarksAll;
